import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/smcTag';
import { listNavigator } from 'sagas/common';
import { filters } from 'filters/smcTag';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Smctag', confirmUpdate: true, actions, selectors, filters } );
}
